let consoleError = window.console.error
window.console.error = function customConsoleError(...args) {     // 重定义全局console.error
    if (/Loading chunk .*? failed/.test(JSON.stringify(args))) {    // 当webpack打包后hash改变加载不到文件时，更新url，刷新页面
        let currentRoutePath = localStorage.getItem('currentRoutePath')
        if (currentRoutePath) {
            window.location.href = window.location.origin + currentRoutePath
        }
        window.location.reload()
    }
    consoleError.call(window, ...args)
}
